module.exports = __webpack_public_path__ + "media/flags/bj-328bc662.svg";